import React, { useEffect, createElement } from 'react';
export function SEO() {
  useEffect(() => {
    // Title
    document.title = 'SGHarems.com 新加坡后宫网 | 新加坡高端伴游陪游按摩援交平台 | Singapore Premium Escort Directory';
    // Helper to set or create meta tags
    const setMeta = (attr: string, key: string, content: string) => {
      let el = document.querySelector(`meta[${attr}="${key}"]`) as HTMLMetaElement | null;
      if (!el) {
        el = document.createElement('meta');
        el.setAttribute(attr, key);
        document.head.appendChild(el);
      }
      el.setAttribute('content', content);
    };
    // Meta Description — expanded
    setMeta('name', 'description', 'SGHarems.com 新加坡后宫网 — 新加坡领先的高端伴游、陪游、按摩、援交一站式服务平台。覆盖乌节路、滨海湾、芽笼、圣淘沙等全岛区域，汇聚中国、日本、韩国、越南、泰国等多国佳丽。24小时在线预约，真人验证，隐私保护。Singapore premier escort directory with verified premium companions, massage services across all districts.');
    // Meta Keywords — expanded
    setMeta('name', 'keywords', '新加坡后宫,SGHarems,新加坡伴游,新加坡陪游,新加坡按摩,新加坡援交,Singapore escort,Singapore massage,Singapore companion,新加坡高端伴游,新加坡休闲娱乐,后宫网,sg escort directory,singapore premium escort,新加坡夜生活,芽笼伴游,乌节路伴游,滨海湾伴游,圣淘沙伴游,新加坡KTV,新加坡中国伴游,新加坡日本伴游,新加坡韩国伴游,新加坡越南伴游,新加坡泰国伴游,Singapore nightlife,Geylang escort,Orchard Road escort,Marina Bay escort,Sentosa escort,SG companion service,新加坡商务伴游,新加坡旅游伴游,Singapore escort agency,best escort Singapore');
    // Author
    setMeta('name', 'author', 'SGHarems.com 新加坡后宫网');
    // Robots
    setMeta('name', 'robots', 'index, follow, max-snippet:-1, max-image-preview:large');
    // Canonical
    let canonical = document.querySelector('link[rel="canonical"]') as HTMLLinkElement | null;
    if (!canonical) {
      canonical = document.createElement('link');
      canonical.setAttribute('rel', 'canonical');
      document.head.appendChild(canonical);
    }
    canonical.setAttribute('href', 'https://www.sgharems.com');
    // Open Graph — expanded
    setMeta('property', 'og:title', 'SGHarems.com 新加坡后宫网 | 新加坡高端伴游陪游按摩援交平台');
    setMeta('property', 'og:description', "新加坡后宫网是新加坡领先的高端伴游陪游按摩援交一站式平台，覆盖全岛，汇聚多国佳丽，24小时在线预约。SGHarems — Singapore's premier escort and companion directory with verified premium companions.");
    setMeta('property', 'og:type', 'website');
    setMeta('property', 'og:url', 'https://www.sgharems.com');
    setMeta('property', 'og:site_name', 'SGHarems.com 新加坡后宫网');
    setMeta('property', 'og:locale', 'zh_CN');
    setMeta('property', 'og:locale:alternate', 'en_SG');
    // Twitter Card
    setMeta('name', 'twitter:card', 'summary_large_image');
    setMeta('name', 'twitter:title', 'SGHarems.com 新加坡后宫网 | 新加坡高端伴游按摩平台');
    setMeta('name', 'twitter:description', '新加坡后宫网 — 高端伴游、陪游、按摩、援交一站式服务平台，覆盖新加坡全岛。Singapore premium escort & companion directory.');
    // JSON-LD Structured Data
    let jsonLd = document.querySelector('script[data-seo="jsonld"]') as HTMLScriptElement | null;
    if (!jsonLd) {
      jsonLd = document.createElement('script');
      jsonLd.setAttribute('type', 'application/ld+json');
      jsonLd.setAttribute('data-seo', 'jsonld');
      document.head.appendChild(jsonLd);
    }
    jsonLd.textContent = JSON.stringify({
      '@context': 'https://schema.org',
      '@type': 'WebSite',
      name: 'SGHarems.com 新加坡后宫网',
      alternateName: ['新加坡后宫网', 'SGHarems', 'Singapore Harem', '后宫网'],
      url: 'https://www.sgharems.com',
      description: '新加坡领先的高端伴游、陪游、按摩、援交一站式服务平台。Singapore premier escort directory with verified premium companions.',
      inLanguage: ['zh-CN', 'en'],
      potentialAction: {
        '@type': 'SearchAction',
        target: 'https://www.sgharems.com/search?q={search_term_string}',
        'query-input': 'required name=search_term_string'
      }
    });
    // FAQ Structured Data
    let faqLd = document.querySelector('script[data-seo="faq"]') as HTMLScriptElement | null;
    if (!faqLd) {
      faqLd = document.createElement('script');
      faqLd.setAttribute('type', 'application/ld+json');
      faqLd.setAttribute('data-seo', 'faq');
      document.head.appendChild(faqLd);
    }
    faqLd.textContent = JSON.stringify({
      '@context': 'https://schema.org',
      '@type': 'FAQPage',
      mainEntity: [{
        '@type': 'Question',
        name: '新加坡后宫网是什么？What is SGHarems?',
        acceptedAnswer: {
          '@type': 'Answer',
          text: "SGHarems.com（新加坡后宫网）是新加坡领先的高端伴游、陪游、按摩及援交综合服务平台，覆盖新加坡全岛。SGHarems.com is Singapore's leading premium escort, companion, and massage service directory."
        }
      }, {
        '@type': 'Question',
        name: '新加坡后宫网覆盖哪些区域？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: '覆盖新加坡全岛，包括中央商务区、乌节路、滨海湾、芽笼、武吉士、克拉码头、圣淘沙、樟宜、裕廊、淡滨尼、兀兰等所有主要区域。'
        }
      }, {
        '@type': 'Question',
        name: '如何联系新加坡后宫网？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: '您可以访问 SGHarems.com 官网，或加入我们的 Telegram 频道 t.me/gl777net 获取最新信息和预约服务。'
        }
      }, {
        '@type': 'Question',
        name: '新加坡后宫网有哪些服务？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: '我们提供高端伴游、私人陪游、专业按摩、SPA水疗、商务伴游、旅游陪同等多种服务，所有服务人员均经过严格身份验证。'
        }
      }]
    });
    // Language
    document.documentElement.lang = 'zh-CN';
  }, []);
  return null;
}